import React, { useEffect, useMemo } from "react";
import { Grid, TextInput, Text } from "@mantine/core";
import {
  formatArFormDisplayDate,
  getArFormValues,
  getPrimaryConsultantFromForm,
  resolveAdvisorDeclaration,
  syncAdvisorDeclaration,
} from "../helpers/arFormUtils";
import OrderArFormBlock, { OrderArFormStack } from "./orderArFormBlock";

const declarationFieldStyles = {
  label: {
    minHeight: 44,
    lineHeight: 1.35,
    display: "block",
    whiteSpace: "normal",
  },
};

const BilingualFieldLabel = ({ english, chinese }) => (
  <>
    {english}
    <br />
    {chinese}
  </>
);

const DisplayField = ({ label, value }) => (
  <div>
    <Text size="xs" color="dimmed" mb={4}>
      {label}
    </Text>
    <Text size="sm">{value || "—"}</Text>
  </div>
);

const OrderArFormPartD = ({ form }) => {
  const arForm = getArFormValues(form);
  const consultant = useMemo(
    () => getPrimaryConsultantFromForm(form),
    [form.values?.orderId?.consultants]
  );

  useEffect(() => {
    syncAdvisorDeclaration(form, consultant);
  }, [form, consultant]);

  const advisorDeclaration = resolveAdvisorDeclaration(
    arForm.advisorDeclaration,
    consultant
  );

  return (
    <OrderArFormStack>
      <OrderArFormBlock
        title="Advisor declaration"
        subtitle="理財顧問聲明"
      >
        <Grid gutter="md" align="flex-start">
          <Grid.Col span={12} md={6}>
            <TextInput
              styles={declarationFieldStyles}
              label={
                <BilingualFieldLabel
                  english="Signature of Advisor"
                  chinese="理財顧問簽署"
                />
              }
              value={advisorDeclaration.signature ?? ""}
              readOnly
            />
          </Grid.Col>
          <Grid.Col span={12} md={6}>
            <TextInput
              styles={declarationFieldStyles}
              label={
                <BilingualFieldLabel
                  english="Sign Date (dd/mm/yyyy)"
                  chinese="簽署日期"
                />
              }
              value={formatArFormDisplayDate(advisorDeclaration.signDate)}
              readOnly
            />
          </Grid.Col>
          <Grid.Col span={12} md={6}>
            <DisplayField
              label={
                <BilingualFieldLabel
                  english="Staff Code"
                  chinese="員工編號"
                />
              }
              value={advisorDeclaration.staffCode}
            />
          </Grid.Col>
          <Grid.Col span={12} md={6}>
            <DisplayField
              label={
                <BilingualFieldLabel
                  english="SFC CE No."
                  chinese="證監會中央編號"
                />
              }
              value={advisorDeclaration.sfcCeNo}
            />
          </Grid.Col>
        </Grid>
      </OrderArFormBlock>
    </OrderArFormStack>
  );
};

export default OrderArFormPartD;
